export const makeMap = <V, K extends string = string>(obj: Record<K, V>): Map<K, V> => {
  return new Map<K, V>(Object.entries(obj) as [K, V][]);
};
